import { render, staticRenderFns } from "./app.vue?vue&type=template&id=6f8d306b&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8d306b')) {
      api.createRecord('6f8d306b', component.options)
    } else {
      api.reload('6f8d306b', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=6f8d306b&", function () {
      api.rerender('6f8d306b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/app/app.vue"
export default component.exports